import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Info, Mail, Bug, LogOut, X, Menu, Home } from 'lucide-react';
import logo from "../assets/logo (2).png";

export default function Navbar() {
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role; // "MANAGER" ou "TRADESMAN"
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const dashboardPath =
    role === "MANAGER" ? "/manager-dashboard" : "/tradesman-dashboard";


  const handleLogoutAttempt = () => {
    setShowLogoutModal(true);
    setMobileMenuOpen(false); // Fermer le menu mobile lors du logout
  };

  // const handleLogoutConfirm = () => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("user");
  //   sessionStorage.setItem("redirectMessage", "You have been logged out.");
  //   setShowLogoutModal(false);
  //   navigate("/");
  // };

  const handleLogoutConfirm = async () => {
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");

  try {
    // Blackliste le access token
    if (token) {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
    }

    // Blackliste aussi le refresh token
    if (refreshToken) {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${refreshToken}` },
      });
    }
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken"); 
    localStorage.removeItem("user");
    sessionStorage.setItem("redirectMessage", "You have been logged out.");
    setShowLogoutModal(false);
    navigate("/");
  }
};

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      sessionStorage.setItem("redirectMessage", "Please log in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  const LogoutConfirmationModal = ({ onCancel, onConfirm }) => {
    return (
      <div className="fixed inset-0 bg-blue-900 bg-opacity-75 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm transform transition-all">
          <div className="border-t-4 border-yellow-500 bg-gray-50 px-6 py-4 rounded-t-lg flex items-center justify-between">
            <h3 className="text-xl font-bold text-blue-900">Logout Confirmation</h3>
            <button
              onClick={onCancel}
              className="text-gray-400 hover:text-gray-700 transition-colors p-1"
              aria-label="Close modal"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <p className="text-gray-600 mb-6 ml-4 mt-4">
            Are you sure you want to log out? You will be redirected to the login page.
          </p>

          <div className="flex flex-col gap-3 sm:flex-row-reverse m-4">
            <button
              onClick={onConfirm}
              className="flex-1 text-white font-semibold shadow-md flex items-center justify-center gap-2 bg-yellow-500 px-4 py-3 rounded-lg hover:bg-yellow-600 transition-colors"
            >
              Yes, Logout
            </button>
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 text-gray-700 font-semibold bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <nav className="bg-blue-900 text-white shadow-lg">
      <div className="max-w-full mx-auto px-4">
        <div className="flex justify-between items-center h-16">

          {/* Logo */}
          <div className="flex items-center gap-3">
            <img src={logo} alt="Tradie Time Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold">TRADIE <span className="text-yellow-500">TIME</span></span>
          </div>

          {/* Menu Desktop */}
          <div className="hidden md:flex items-center gap-6">
            <Link
              to={dashboardPath}
              className={`flex items-center gap-2 transition-colors ${location.pathname === dashboardPath
                ? "text-yellow-500 font-semibold"
                : "hover:text-yellow-500"
                }`}
            >
              <Home className="w-5 h-5" />
              <span>Dashboard</span>
            </Link>
            <Link
              to="/about"
              className={`flex items-center gap-2 transition-colors ${location.pathname === "/about"
                ? "text-yellow-500 font-semibold"
                : "hover:text-yellow-500"
                }`}
            >
              <Info className="w-5 h-5" />
              <span>About</span>
            </Link>

            <a
              href="mailto:admin@tradietime.co.nz"
              className="flex items-center gap-2 hover:text-yellow-500 transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span>Contact</span>
            </a>

            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdgh9wDY6KG5peKcRKVI0cYmxeNXY4fc-IxyHhg-dthA5A8nA/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-yellow-500 transition-colors"
            >
              <Bug className="w-5 h-5" />
              <span>Report Bug</span>
            </a>

            <button
              onClick={handleLogoutAttempt}
              className="flex items-center gap-2 bg-yellow-500 px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors font-semibold text-blue-900"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>

          {/* Bouton Menu Mobile */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-blue-800 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Menu Mobile */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-blue-800 py-4">
            <div className="flex flex-col gap-4">

              <Link
                to={dashboardPath}
                onClick={closeMobileMenu}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === dashboardPath
                  ? "bg-blue-800 text-yellow-400 font-semibold"  // 🔹 couleur quand actif
                  : "hover:bg-blue-800"
                  }`}
              >
                <Home className="w-5 h-5" />
                <span>Dashboard</span>
              </Link>


              <Link
                to="/about"
                onClick={closeMobileMenu}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === "/about"
                    ? "bg-blue-800 text-yellow-400 font-semibold"
                    : "hover:bg-blue-800"
                  }`}
              >
                <Info className="w-5 h-5" />
                <span>About</span>
              </Link>


              <a
                href="mailto:admin@tradietime.co.nz"
                onClick={closeMobileMenu}
                className="flex items-center gap-3 px-4 py-3 hover:bg-blue-800 rounded-lg transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>Contact</span>
              </a>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdgh9wDY6KG5peKcRKVI0cYmxeNXY4fc-IxyHhg-dthA5A8nA/viewform"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                className="flex items-center gap-3 px-4 py-3 hover:bg-blue-800 rounded-lg transition-colors"
              >
                <Bug className="w-5 h-5" />
                <span>Report Bug</span>
              </a>

              <button
                onClick={handleLogoutAttempt}
                className="flex items-center gap-3 bg-yellow-500 px-4 py-3 rounded-lg hover:bg-yellow-600 transition-colors font-semibold text-blue-900 mx-4"
              >
                <LogOut className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal de confirmation de logout */}
      {showLogoutModal && (
        <LogoutConfirmationModal
          onCancel={handleLogoutCancel}
          onConfirm={handleLogoutConfirm}
        />
      )}
    </nav>
  );
}